import { reactive, computed, watch } from '@vue/composition-api'
import { formatDate, breakComma, isPc } from '@/util/common'
import { PREFEX_EXTRACT_CONDITION } from '@/util/constants'
import * as _ from 'lodash'
import { openPrecedentSearch } from '@/logic/common/CommonPrecedent'

export const HistoryOfSearch = (props, context) => {
  const store = context.root.$store
  const router = context.root.$router
  const { searchHistory } = store.state

  const data = reactive({
    // 日付でソートされたリスト
    lists: computed(() => searchHistory.lists),
    count: computed(() => searchHistory.count),
    // 絞り込みはAPI側で実行するため、日付のグルーピングのみおこなう
    groupDateLists: computed(() => _.groupBy(data.lists, 'date')),
    // 全読み込み済みフラグ
    complete: computed(() => searchHistory.complete),
    canload: computed(() => searchHistory.canload),
    filterTypes: searchHistory.filterTypes
  })

  const state = reactive({
    visibleToast: false,
    visibleHistoryOfSearchDeleteConfirm: false,
    visibleHistoryOfSearchDeleteInBulkConfirm: false,
    visibleProfile: false,
    additionalLoading: true,
    canload: true
  })

  const openProfile = () => {
    context.refs.menu.state.visibleProfile = true
  }

  // タイプの絞り込みを監視し、変更があればリストをリセットする
  watch(() => data.filterTypes, (newVal, oldVal) => {
    if (!oldVal) return
    debounceFilterTypes(newVal)
  })
  // 連続押下時にAPIを連続で呼ばないように間隔をあけて実行する
  const debounceFilterTypes = _.debounce((params) => {
    store
      .dispatch('searchHistory/changeFilterTypes', params)
      .then(() => {
        store.dispatch('searchHistory/getLists')
      })
  }, 500)

  const action = {
    load: () => {
      store.dispatch('searchHistory/getLists')
    },
    deleteItem: (id) => {
      store.dispatch('searchHistory/setEditId', id)
      state.visibleHistoryOfSearchDeleteConfirm = true
    },
    routeList: (list) => {

      const id = list.id
      const searchCategory = list.type

      // 遷移先とstoreのアクション名を設定
      const target = (() => {
        switch (searchCategory) {
          case 'qa': return {
            name: isPc() ? 'PCQAList' : 'SPQAList',
            action: 'search/setQASearchParam',
            actionExtract: 'search/setQASearchExtractParam'
          }
          case 'knowledge': return {
            name: isPc() ? 'PCKnowledgeList' : 'SPKnowledgeList',
            action: 'search/setKnowledgeSearchParam'
          }
          case 'note': return {
            name: isPc() ? 'PCNoteList' : 'SPNoteList',
            action: 'search/setNoteSearchParam'
          }
          case 'pj': return {
            name: isPc() ? 'PCDocumentList' : 'SPDocumentList',
            action: 'search/setPrecedentSearchParam'
          }
          default: return {
            name: isPc() ? 'PCQAList' : 'SPQAList',
            action: 'search/setQASearchParam'
          }
        }
      })()

      // APIからの返却値を使いやすい形に調整
      const searchParamsWork = _.fromPairs(_.map(list.search, param => [param.key, param.value]))

      // 検索一覧表示用の検索条件と、絞り込み表示用の検索条件を分離
      const searchParams = {}
      const searchExtractParams = {}
      for (const key in searchParamsWork) {
        const value = searchParamsWork[key]
        if (key.indexOf(PREFEX_EXTRACT_CONDITION) >= 0) {
          // 絞り込み表示用の検索条件には、接頭辞「extract:」が付与されている
          const key2 = key.replace(PREFEX_EXTRACT_CONDITION, '') // 接頭辞を削除
          searchExtractParams[key2] = value
        } else {
          searchParams[key] = value
        }
      }

      if (typeof target.actionExtract !== 'undefined') {
        // 絞り込み表示用の検索条件をストアに保持
        store.dispatch(target.actionExtract, searchExtractParams)
      }

      // 検索UI(PCSearchUI/SPSearchUI)の検索テキストと曖昧フラグを更新する
      let searchText = ''
      if (searchCategory === 'qa') {
        searchText = searchParams.search_text ?? ''
      } else if (searchCategory === 'note') {
        searchText = searchParams.search_text ?? ''
      } else if (searchCategory === 'knowledge') {
        searchText = searchParams.keyword ?? ''
      } else if (searchCategory === 'pj') {
        searchText = searchParams.search_text ?? ''
      }
      const isFuzzy = searchParams.is_fuzzy ?? 0
      store.dispatch('searchUI/setSearchInputOfSearchUI', { searchText: searchText, isFuzzy: isFuzzy })
      store.dispatch('searchUI/setSearchInputOfSearchUIParam', { searchCategory: searchCategory, searchText: searchText, isFuzzy: isFuzzy })

      // ストアに検索条件を保持し、遷移する
      store
        .dispatch(target.action, searchParams)
        .then(() => {
          if (searchCategory === 'pj') {
            // 資料検索の検索画面を別ウィンドウで開く
            openPrecedentSearch(id)
          } else {
            router.push({ name: target.name })
          }
        })
    }
  }

  // 初回リスト読み込み
  action.load()

  return {
    state,
    data,
    formatDate,
    breakComma,
    openProfile,
    action
  }
}
